/* @flow weak */
// ES5+ polyfills
// These consist of all the polyfills required by Babel.
import 'babel-polyfill';
import idx from 'idx';
import currentUserAgent from 'lib/currentUserAgent';
// We use console.debug so that browser console can filter the level. Node
// doesn't have console.debug
if (typeof console.debug === 'undefined') {
  // $FlowFixMe adding new property
  console.debug = console.info;
}

// FROM https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob#Polyfill
// We also have https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl.~locale.en,HTMLCanvasElement.prototype.toBlob
// but it doesn't seem to be working in IE11
/* eslint-disable */
if (!HTMLCanvasElement.prototype.toBlob) {
  // $FlowFixMe
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function(callback, type, quality) {
      var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
        len = binStr.length,
        arr = new Uint8Array(len);

      for (var i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(new Blob([arr], { type: type || 'image/png' }));
    },
  });
}
/* eslint-enable */

// Our Intl polyfill isn't being loaded sometimes, despite it being included in our polyfill.io request
// Manually polyfill it
if (!global.Intl) {
  global.Intl = require('intl');
  require('intl/locale-data/jsonp/en.js');
}

// Fix for regex issue when parsing dates on Safari 9
// e.g. https://rollbar.com/Remind/r101-frontend/items/14701/
// https://github.com/andyearnshaw/Intl.js/issues/231
if (currentUserAgent.safari() && idx(global, _ => _.Intl.__disableRegExpRestore)) {
  global.Intl.__disableRegExpRestore();
}
// Left here in case we need this again. For now we handle any asynchronous polyfills
// before our app starts at all, using https://polyfill.io/
// Asynchronous polyfills
// $FlowIssue
export default Promise.resolve();
